<template>
    <el-drawer title="设置类型规则" :visible.sync="visible" :wrapperClosable="false" size="60%">
        <div class="draw-form">
            <el-divider content-position="left">
                <el-button type="primary" @click="showDrawerPass(_self, 'addRule', 'showDialog', [rules.length])">追加规则</el-button>
            </el-divider>
            <el-form :model="form" label-width="100px" label-position="left" style="margin-top:12px;">
                <template v-for="(attr,index) in rules">
                    <el-form-item :label="attr.label" :key="index">
                        <el-col :span="12">
                            <el-input v-if="attr.type == 'text'" v-model="form[attr.field]" :placeholder="attr.label"></el-input>
                            <el-input v-else-if="attr.type == 'number'" v-model="form[attr.field]" type="number" :placeholder="attr.label"></el-input>
                            <el-date-picker v-else-if="attr.type == 'date'" type="date" :placeholder="attr.label" v-model="form[attr.field]"></el-date-picker>
                            <el-date-picker v-else-if="attr.type == 'datetime'" type="datetime" :placeholder="attr.label" v-model="form[attr.field]"></el-date-picker>
                            <el-select v-else-if="attr.type == 'select'" v-model="form[attr.field]" :placeholder="attr.label">
                                <el-option v-for="(item, index2) in former.getCfgItems(attr.content)" :key="index2" :label="former.getItemLabel(item)" :value="former.getItemValue(item)"></el-option>
                            </el-select>
                            <el-checkbox-group v-else-if="attr.type == 'checkbox'" v-model="form[attr.field]">
                                <el-checkbox v-for="(item, index2) in former.getCfgItems(attr.content)" :key="index2" :label="former.getItemValue(item)">{{former.getItemLabel(item)}}</el-checkbox>
                            </el-checkbox-group>
                            <el-radio-group v-else-if="attr.type == 'radio'" v-model="form[attr.field]">
                                <el-radio v-for="(item, index2) in former.getCfgItems(attr.content)" :key="index2" :label="former.getItemValue(item)">{{former.getItemLabel(item)}}</el-radio>
                            </el-radio-group>
                            <template v-else-if="attr.type == 'upload'">
                                <el-upload :data="token" :action="uploadUrl + '/api/order.upload/doupload'" list-type="picture-card" :file-list="form[attr.field]">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                            </template>
                        </el-col>
                        <el-col :span="6">字段:{{ attr.field }}</el-col>
                        <el-col :span="6">
                            <el-button type="primary" @click="showDrawerPass(_self, 'addRule', 'showDialog', [index])">前插</el-button>
                            <el-button type="primary" @click="showDrawerPass(_self, 'editRule', 'showDialog', [rules, index])">编辑</el-button>
                            <el-button type="danger" @click="removeAttr(index)">删除</el-button>
                        </el-col>
                    </el-form-item>
                </template>

                <el-form-item>
                    <el-button type="primary" @click="onSubmit">保存规则</el-button>
                </el-form-item>
            </el-form>
        </div>
        <add-rule ref="addRule" :parent="_self"></add-rule>
        <edit-rule ref="editRule" :parent="_self"></edit-rule>
    </el-drawer>
</template>

<script>
import {
    showDrawerPass,
} from '@/utils/common.js';
import former from '@/utils/former.js'
import addRule from './addRule.vue'
import editRule from './editRule.vue'
import baseUrl from '@/utils/baseUrl';
export default {
    components: {
        addRule,
        editRule
    },
    data() {
        let uploadUrl = baseUrl;
        return {
            //上传文档
            token: {
                token: localStorage.getItem('token')
            },
            uploadUrl: uploadUrl,
            category_id: '',
            visible: false,
            rules: [],
            form: {}
        }
    },
    beforeCreate() {
        this.showDrawerPass = showDrawerPass;
        this.former = former;
    },
    methods: {
        showDrawer(category_id) {
            this.category_id = category_id;
            this.visible = true;
            // 获取类型的规则
            let _this = this;
            let url = '/api/supplier.category/read';
            let params = {
                id: category_id
            };

            this.$post(url, params).then(res => {
                let category = res.data.row;
                // 格式化规则
                let rules = category.rules;
                rules.forEach(ele => {
                    if (ele.type == "checkbox") {
                        // 应该是重新刷dom的方式
                        _this.$set(_this.form, ele.field, []);
                    }
                });
                _this.rules = rules;
            })

        },
        appendAttr(rule, position) {
            // checkbox 需要初始化数组
            if (rule.type == 'checkbox') {
                // this.form[attr.field] = [];
                // 因为 Vue 无法探测普通的新增 property
                this.$set(this.form, rule.field, [])
            }

            if (position == this.rules.length) {
                // 追加
                this.rules.push(rule);
            } else {
                // 执行插入
                let arr1 = this.rules.slice(0, position);
                arr1.push(rule);
                let arr2 = this.rules.slice(position);
                this.rules = arr1.concat(arr2);
            }
        },
        updateAttr(rule, position) {
            this.rules[position] = rule;
        },
        removeAttr(index) {
            this.$confirm('确定删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.rules.splice(index, 1);
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        onSubmit() {
            let _this = this;
            let url = '/api/supplier.category/save';
            let params = {
                id: this.category_id,
                rules: this.rules
            };
            this.$post(url, params).then(res => {
                if (res.code == '200') {
                    _this.visible = false;
                    _this.$message({
                        type: 'success',
                        message: res.msg
                    });
                } else {
                    _this.$message({
                        type: 'warning',
                        message: res.msg
                    })
                }
            })
        }
    }
}
</script>

<style lang="less">
@import url('@/assets/css/common.less');
</style>
